import { AudioManager } from "./../../../managers/AudioManager";
import { PlayerContainer } from "./PlayerContainer";
import { GameConstants } from "../../../GameConstants";
import { AdversaryContainer } from "./AdversaryContainer";
import { GameVars } from "../../../GameVars";
import { RoomManager } from "../../../managers/RoomManager";

export class PlayersContainer extends Phaser.GameObjects.Container {

    private static ADVERSARIES_POSITIONS = [
        { x: GameConstants.GAME_WIDTH / 2 - 350, y: 400 },
        { x: GameConstants.GAME_WIDTH / 2 - 350, y: 220 },
        { x: GameConstants.GAME_WIDTH / 2 - 30, y: 150 },
        { x: GameConstants.GAME_WIDTH / 2 + 350, y: 220 },
        { x: GameConstants.GAME_WIDTH / 2 + 350, y: 400 }

    ];

    private static PLAYER_POSITION = { x: GameConstants.GAME_WIDTH / 2, y: 510 };

    private adversaries: AdversaryContainer[];
    private player: PlayerContainer;
    private allinBackground: Phaser.GameObjects.Graphics;

    constructor(scene: Phaser.Scene, ids: string[]) {

        super(scene);

        this.adversaries = [];

        this.setPlayer(ids.shift());

        this.setAdversaries(ids);

        this.allinBackground = new Phaser.GameObjects.Graphics(this.scene);
        this.allinBackground.fillStyle(0x000000, .5);
        this.allinBackground.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        this.allinBackground.visible = false;
        this.add(this.allinBackground);
    }

    public showAllinPlayers(): void {

        this.bringToTop(this.allinBackground);
        this.allinBackground.visible = true;

        if (RoomManager.getPlayer(this.player.id)) {
            if (RoomManager.getPlayer(this.player.id).state === GameConstants.ACTIVE) {
                this.bringToTop(this.player);
            } else {
                this.sendToBack(this.player);
            }
        }

        for (let i = 0; i < this.adversaries.length; i++) {
            if (RoomManager.getPlayer(this.adversaries[i].id).state === GameConstants.ACTIVE) {
                this.bringToTop(this.adversaries[i]);
            } else {
                this.sendToBack(this.adversaries[i]);
            }
        }
    }

    public hiedAllinPlayers(): void {

        this.allinBackground.visible = false;
    }

    public showPlayers(): void {

        this.scene.tweens.add({
            targets: this.player,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500 / GameVars.gameSpeed
        });

        for (let i = 0; i < this.adversaries.length; i++) {
            this.scene.tweens.add({
                targets: this.adversaries[i],
                alpha: 1,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 500 / GameVars.gameSpeed
            });
        }
    }

    public addWageredToPot(): void {

        this.player.addWageredToPot();

        for (let i = 0; i < this.adversaries.length; i++) {
            this.adversaries[i].addWageredToPot();
        }
    }

    public addCardsFrames(cards: any[], winnersIds: string[]): void {

        for (let i = 0; i < winnersIds.length; i++) {
            if (this.player.id === winnersIds[i]) {
                this.player.addCardsFrames(cards[i]);
            }

            for (let j = 0; j < this.adversaries.length; j++) {
                if (this.adversaries[j].id === winnersIds[i]) {
                    this.adversaries[j].addCardsFrames(cards[i]);
                }
            }
        }
    }

    public updatePlayerHand(): void {

        this.player.updateHand();
    }

    public hideCurrentPlayerCards(): void {

        let player = GameVars.gameState.players[GameVars.currentTurn];

        for (let i = 0; i < this.adversaries.length; i++) {

            if (player.id === this.adversaries[i].id) {
                this.adversaries[i].setTurn(false);
            }
        }
    }

    public finalizeActions(): void {

        for (let i = 0; i < this.adversaries.length; i++) {

            this.adversaries[i].bot.finalizeActions(GameVars.gameState);
        }
    }

    public markPlayer(): void {

        // this.unmarkPlayers();

        if (this.player.id === GameVars.gameState.players[GameVars.currentTurn].id) {
            this.player.setTurn(true);
        } else {
            for (let i = 0; i < this.adversaries.length; i++) {
                if (this.adversaries[i].id === GameVars.gameState.players[GameVars.currentTurn].id) {
                    this.adversaries[i].setTurn(true);
                }
            }
        }
    }

    public unmarkPlayers(): void {

        this.player.setTurn(false);

        for (let i = 0; i < this.adversaries.length; i++) {
            this.adversaries[i].setTurn(false);
        }
    }

    public updateBets(id: string, type?: string): void {

        if (this.player.id === id) {
            this.player.updateBet(type);
        } else {
            for (let i = 0; i < this.adversaries.length; i++) {
                if (this.adversaries[i].id === id) {
                    this.adversaries[i].updateBet(type);
                }
            }
        }

        this.updateChipsState();
    }

    public updateChipsState(): void {

        if (this.player) {
            this.player.updateChipsState();
        }

        for (let i = 0; i < this.adversaries.length; i++) {
            this.adversaries[i].updateChipsState();
        }
    }

    public updateAllChips(): void {

        this.player.updateChips();
        for (let i = 0; i < this.adversaries.length; i++) {
            this.adversaries[i].updateChips();
        }
    }

    public resetTable(): void {

        this.player.resetTable();

        for (let i = 0; i < this.adversaries.length; i++) {
            this.adversaries[i].resetTable();
        }
    }

    public resetBets(): void {

        AudioManager.playSound("total_pot_fx");

        this.player.resetBet();

        for (let i = 0; i < this.adversaries.length; i++) {
            this.adversaries[i].resetBet();
        }
    }

    public getBet(id: string): { bet: number, bluff: boolean, handScore: number } {

        for (let i = 0; i < this.adversaries.length; i++) {
            if (this.adversaries[i].id === id) {
                return this.adversaries[i].bot.getBet(GameVars.gameState);
            }
        }
    }

    public bluffAnimation(id: string): void {

        for (let i = 0; i < this.adversaries.length; i++) {
            if (this.adversaries[i].id === id) {
                this.adversaries[i].bluffAnimation();
            }
        }
    }

    public decisionAnimation(id: string): void {

        for (let i = 0; i < this.adversaries.length; i++) {
            if (this.adversaries[i].id === id) {
                this.adversaries[i].decisionAnimation();
            }
        }
    }

    public inactivePlayer(id: string): void {

        if (this.player.id === id) {
            this.player.inactive();
        } else {
            for (let i = 0; i < this.adversaries.length; i++) {
                if (this.adversaries[i].id === id) {
                    this.adversaries[i].inactive();
                }
            }
        }
    }

    public dealPlayersCards(): void {

        this.player.addPlayerCards();

        for (let i = 0; i < this.adversaries.length; i++) {
            this.adversaries[i].addAdversaryHiddenCards();
        }
    }

    public showCards(lastPlayer?: boolean): void {

        let cards = [];

        if (RoomManager.getPlayer(this.player.id) && RoomManager.getPlayer(this.player.id).state !== GameConstants.INACTIVE) {
            this.player.showPlayerCards();
            if (lastPlayer) {
                cards = GameVars.gameState.community.concat(RoomManager.getPlayer(this.player.id).cards);

                if (Hand.solve(cards).name === "High Card") {
                    this.player.credibility = this.player.credibility === 0 ? 0 : this.player.credibility - 10;
                } else {
                    this.player.credibility = this.player.credibility === 100 ? 100 : this.player.credibility + 10;
                }
            }
        }

        for (let i = 0; i < this.adversaries.length; i++) {
            if (RoomManager.getPlayer(this.adversaries[i].id) && RoomManager.getPlayer(this.adversaries[i].id).state !== GameConstants.INACTIVE) {
                this.adversaries[i].showAdversaryCards();
                if (lastPlayer) {
                    cards = GameVars.gameState.community.concat(RoomManager.getPlayer(this.adversaries[i].id).cards);

                    if (Hand.solve(cards).name === "High Card") {
                        this.adversaries[i].bot.attributes.credibility = this.player.credibility === 0 ? 0 : this.player.credibility - 10;
                    } else {
                        this.adversaries[i].bot.attributes.credibility = this.player.credibility === 100 ? 100 : this.player.credibility + 10;
                    }
                }
            }
        }

        if (lastPlayer) {

            if (Hand.solve(cards).name === "High Card") {
                for (let i = 0; i < this.adversaries.length; i++) {
                    if (RoomManager.getPlayer(this.adversaries[i].id) && RoomManager.getPlayer(this.adversaries[i].id).state === GameConstants.INACTIVE) {
                        this.adversaries[i].reactionCardsShown();
                    }
                }
            }
        }
    }

    public decideShowCards(): void {

        let cardsShown = false;
        let cards = [];

        for (let i = 0; i < this.adversaries.length; i++) {
            if (RoomManager.getPlayer(this.adversaries[i].id) && RoomManager.getPlayer(this.adversaries[i].id).state !== GameConstants.INACTIVE) {
                cardsShown = this.adversaries[i].decideShowAdversaryCards();
                cards = GameVars.gameState.community.concat(RoomManager.getPlayer(this.adversaries[i].id).cards);
            }
        }

        if (cardsShown && Hand.solve(cards).name === "High Card") {
            for (let i = 0; i < this.adversaries.length; i++) {
                if (RoomManager.getPlayer(this.adversaries[i].id) && RoomManager.getPlayer(this.adversaries[i].id).state === GameConstants.INACTIVE) {
                    this.adversaries[i].reactionCardsShown();
                }
            }
        }
    }

    public showLosers(ids: string[]): void {

        for (let j = 0; j < this.adversaries.length; j++) {

            let needShowLosser = true;
            for (let i = 0; i < ids.length; i++) {
                if (ids[i] === this.adversaries[j].id) {
                    needShowLosser = false;
                }
            }

            if (needShowLosser && RoomManager.getPlayer(this.adversaries[j].id).state === GameConstants.ACTIVE) {
                this.adversaries[j].showLoser();
            }
        }
    }

    public showWinners(ids: string[]): void {

        let playerWinner = false;

        for (let i = 0; i < ids.length; i++) {
            if (ids[i] === this.player.id) {
                this.player.showWinner();
                playerWinner = true;
                break;
            }
        }

        for (let j = 0; j < this.adversaries.length; j++) {

            let needShowLosser = true;
            for (let i = 0; i < ids.length; i++) {
                if (ids[i] === this.adversaries[j].id) {
                    this.adversaries[j].showWinner(playerWinner);
                    needShowLosser = false;
                }
            }
        }
    }

    public potToPlayer(ids: string[]): void {

        for (let i = 0; i < ids.length; i++) {
            if (ids[i] === this.player.id) {
                this.player.potToPlayer();
                break;
            }
        }

        for (let j = 0; j < this.adversaries.length; j++) {
            for (let i = 0; i < ids.length; i++) {
                if (ids[i] === this.adversaries[j].id) {
                    this.adversaries[j].potToPlayer();
                }
            }
        }
    }

    public getDealer(): number {

        if (RoomManager.getPlayer(this.player.id) && RoomManager.getPlayer(this.player.id).position === GameVars.gameState.players.length - 1) {
            return this.player.positionInTable;
        } else {
            for (let i = 0; i < this.adversaries.length; i++) {
                if (RoomManager.getPlayer(this.adversaries[i].id) && RoomManager.getPlayer(this.adversaries[i].id).position === GameVars.gameState.players.length - 1) {
                    return this.adversaries[i].positionInTable;
                }
            }
        }
    }

    public removeEliminatedPlayers(): void {

        if (!RoomManager.getPlayer(this.player.id)) {
            this.player.eliminatePlayer();
            GameVars.gameOver = true;
        }

        for (let i = 0; i < this.adversaries.length; i++) {
            if (this.adversaries[i] && !RoomManager.getPlayer(this.adversaries[i].id)) {
                GameVars.points[this.adversaries[i].id] += (5 - this.adversaries.length);
                this.adversaries[i].eliminatePlayer();
                this.adversaries.splice(i, 1);
                i--;
            }
        }
    }

    public getCredibility(id: string): any {

        if (RoomManager.getPlayer(this.player.id) && this.player.id === id) {
            return this.player.credibility;
        }

        for (let i = 0; i < this.adversaries.length; i++) {
            if (this.adversaries[i].id === id) {
                return this.adversaries[i].bot.attributes.credibility;
            }
        }
    }

    public setPlayerRivalry(id: string, winners: string[]) {

        for (let i = 0; i < this.adversaries.length; i++) {

            if (this.adversaries[i].id === id) {

                for (let j = 0; j < winners.length; j++) {

                    if (winners[j] !== this.adversaries[j].id) {
                        this.adversaries[i].bot.rivalry[winners[j]] = this.adversaries[i].bot.rivalry[winners[j]] === 100 ? 100 : this.adversaries[i].bot.rivalry[winners[j]] + 10;
                    }
                }
            }
        }
    }

    private setAdversaries(ids: string[]): void {

        for (let i = 0; i < GameVars.gameState.players.length - 1; i++) {

            const px = PlayersContainer.ADVERSARIES_POSITIONS[i].x;
            const py = PlayersContainer.ADVERSARIES_POSITIONS[i].y;

            const p = RoomManager.getPlayer(ids[i]);

            const adversaryAvatarContainer = new AdversaryContainer(this.scene, p.x ? p.x : px, p.y ? p.y : py, i + 1, false, ids[i]);
            this.add(adversaryAvatarContainer);

            p.x = adversaryAvatarContainer.x;
            p.y = adversaryAvatarContainer.y;

            this.adversaries.push(adversaryAvatarContainer);
        }
    }

    private setPlayer(id: string): void {

        const p = RoomManager.getPlayer(id);

        this.player = new PlayerContainer(this.scene, p.x ? p.x : PlayersContainer.PLAYER_POSITION.x, p.y ? p.y : PlayersContainer.PLAYER_POSITION.y, 0, id);
        this.add(this.player);
        p.x = this.player.x;
        p.y = this.player.y;
    }
}
